

































































































import Vue from 'vue';
import { getEventWithGuestCategoryCounters } from '@/modules/event/event.service';
import { getSubscription,patchSubscriptionCheckIn } from '@/modules/event/subscription.service';
import { QrcodeStream } from 'vue-qrcode-reader';
import SubscriptionGuestAnswers from '@/components/SubscriptionGuestAnswers';
import { UserRoles } from '@/modules/auth/auth.model';
import SubscriptionPaymentDetailsForm from '@/components/SubscriptionPaymentDetailsForm';
import { getEventsPaymentOptions } from '@/modules/event/payment-options.service';

export default Vue.extend({
    name: 'EventManage',
    components: { QrcodeStream, SubscriptionGuestAnswers, SubscriptionPaymentDetailsForm},
    props: ['formTitle','formAction','dataEventProp'],
    data: () => ({
      readQrcode: true,
      msgError: '',
      msgSuccess: '',
      qrcodeRead: {data:'',dataType:''},
      eventId: 0,
      subscriptionId: 0,
      eventData: {
        name:'',
        date:'',
        dateString: '',
        paymentEnabled: false
      },
      eventCounter: {},
      subscriptionFound: {},
      isUser: false,
      isSiteManager: false,
      isAdmin: false,
      paymentOptions: []

    }),
    mounted() {
      this.initProps();
      this.getEventData();
      const role = localStorage.getItem('user-role');
      if (role === UserRoles.SITEMNGR.key){
        this.isSiteManager = true;
      }else if (role === UserRoles.ADMIN.key){
        this.isAdmin = true;
      }else if (role === UserRoles.USER.key){
        this.isUser = true;
      }
      getEventsPaymentOptions(this.eventId).then(res=>{
        if(res.data) {
          this.paymentOptions = res.data;

        } else if(res.error) {
          this.msgError = 'Erreur. Impossible de récupérer les données pour le paiement.'
        }
      });
    },
    methods: {
      onDecode (result) {
        try{
          this.qrcodeRead = JSON.parse(result);
          const re=/^[0-9]+$/;
          if (result && this.qrcodeRead.dataType && this.qrcodeRead.dataType != 'subscriptionId'){
            this.msgError = "Le QRcode n'est pas compatible";
          }else if (result && this.qrcodeRead.data && this.qrcodeRead.data != ''&& re.test(this.qrcodeRead.data) && parseInt(this.qrcodeRead.data)){
            this.subscriptionId = parseInt(this.qrcodeRead.data);
            getSubscription(this.subscriptionId).then(res => {
              if (res.data){
                this.subscriptionFound = res.data;
                if (this.subscriptionFound.eventId != this.eventId){
                  this.resetSubscriptionData();
                  this.msgError = "Le QRcode ne correspond pas à cette événement";
                  this.readQrcode=true;
                }else{
                  this.resetMessages();
                  this.readQrcode=false;
                }
              }else if (res.error){
                this.msgError = "Le QRcode n'est pas compatible";
              }
            });
            
          }else{
            this.msgError = "Le QRcode n'est pas compatible";
          }
        }catch (e){
          this.msgError = "Le QRcode n'est pas compatible";
        }
        
      },
      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.msgError = "ERREUR : Veuillez donner accès à la caméra"
          } else if (error.name === 'NotFoundError') {
            this.msgError = "ERREUR: aucune caméra trouvée"
          } else if (error.name === 'NotSupportedError') {
            this.msgError = "ERREUR: connexion non sécurisée"
          } else if (error.name === 'NotReadableError') {
            this.msgError = "ERREUR: impossible de lire la caméra, est-ce qu'elle est utilisée ?"
          } else if (error.name === 'OverconstrainedError') {
            this.msgError = "ERREUR : la caméra détecté n'est pas compatible"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.msgError = "ERREUR : le navigateur est incompatible"
          }
        }
      },
      retour(){
        this.$router.push('/evenements');        
      },
      cancelCheckIn(){
        this.readQrcode=true;
        this.resetSubscriptionData();
      },
      openSubscriptions(){
        if (this.eventData.paymentEnabled){
          this.$router.push('/evenement/gestion/inscrits-detail?id='+this.eventId);
        }else{
          this.$router.push('/evenement/gestion/inscrits?id='+this.eventId);
        }
      },
      newSubscription(){
        this.$router.push('/inscription?id_event='+this.eventId);        
      },
      editSubscription(){
        this.$router.push('/inscription?id_event='+this.eventId+'&id_subscription='+this.subscriptionId);        
      },
      checkInSubscription(){
        if (this.subscriptionId != 0){
          patchSubscriptionCheckIn(this.subscriptionId).then(res => {
              if (res.data){
                this.readQrcode=true;
                this.resetSubscriptionData();
                this.getEventData();
              }else if (res.error){
                this.msgError = 'Erreur dans la modification de l\'inscription';
              }
            });
        }else{
          this.msgError = 'Erreur : aucune inscription trouvée';
        }

      },
      getEventData(){
        if (this.$route.query.id){
          this.eventId = parseInt(this.$route.query.id?this.$route.query.id:'');
          getEventWithGuestCategoryCounters(this.eventId).then(res => {
            if (res.data){
              if (document && document.title) document.title = (res.data.event&&res.data.event.name)?(res.data.event.name+' LePhare'):'Evénement LePhare&LaSource';

              this.eventData = res.data.event;
              this.eventCounter = res.data.counters;              
              const date = new Date(this.eventData.date);
              this.eventData.dateString = ((date.getDate()<10)?('0'+date.getDate()):date.getDate())+'/'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'/'+date.getFullYear();
            }else if (res.error){
              this.msgError = 'Erreur dans la recupération de l\'événement.'
            }
          });
        }
      },
      initProps() {
        if (this.dataEventProp){
          this.eventData = this.dataEventProp;
        }
      },
      resetEventData(){
        this.eventData = {
          name:'',
          date:'',
          dateString:'',
          paymentEnabled: false
        };
        this.resetMessages();
      },
      resetSubscriptionData(){
        this.subscriptionId = 0;
        this.subscriptionFound = {};
        this.resetMessages();
      },
      resetMessages(){
        this.msgError = '';
        this.msgSuccess = '';
      }
    }
  })
